import { Injectable } from '@angular/core';
import { CalculationService } from '../../calculation.service';
import { CalculationStorageService } from '../../../../../shared/services/calculation-storage.service';
import { AgreementModel } from '../../../../models/agreement.model';
import {RegistrationService} from '../../registration.service';
import {RegistrationStorageService} from '../../../../../shared/services/registration-storage.service';
import {AgreementsService} from '../../../../../shared/services/agreements.service';

@Injectable({
  providedIn: 'root'
})
export class ContactDataStateService {

  constructor(private logicService: CalculationService,
              private agreementsService: AgreementsService,
              private registrationService: RegistrationService,
              private calculationStorage: CalculationStorageService,
              private registrationStorage: RegistrationStorageService) {
  }

  get contactDataBean(): any {
    return {
      ...this.logicService.contactData,
      agreements: this.logicService.agreements
    };
  }

  get agreements(): AgreementModel[] {
    return this.logicService.agreements;
  }

  set agreements(agreements: AgreementModel[]) {
    this.logicService.agreements = agreements;
  }

  changeEmail(email: string): void {
    this.logicService.contactData.email = email;
    this.calculationStorage.updateCalculation();
  }

  changePhoneNumber(phoneNumber: string): void {
    this.logicService.contactData.phoneNumber = phoneNumber;
    this.registrationService.contactData.phoneNumber = phoneNumber;
    this.calculationStorage.updateCalculation();
    this.registrationStorage.updateRegistration();
  }

  changeAgreement(code: string, selected: boolean): void {
    this.agreementsService.changeAgreement(code, selected);
  }

}
